<template>
  <div id="SendFileToAdmin" dir="rtl">
    <loading v-if="Loading"></loading>
    <panel
      Title="ارسال فایل و مدارک"
      Des="از طریق این فرم می‌توانید فایل‌های خواسته شده را برای مدیر سامانه ارسال نمایید"
      :IsBtnBack="true"
      ClassCustom="bg-dark-Custom text-right mt-2"
    ></panel>
    <div class="row px-3">
      <div class="col-12 col-md-12 mx-md-2 p-md-3">
        <net-pa-tab
          :Tabs="SendFileTabs"
          :Active="activeTab"
          @change="onTabChange"
        ></net-pa-tab>
        <div class="tab-content" id="nav-tabContent">
          <div
            class="tab-pane fade"
            :class="{ 'show active': activeTab === 'nav-send-form' }"
            id="nav-send-form"
            role="tabpanel"
            aria-labelledby="nav-send-form-tab"
          >
            <net-pa-card :Compact="true">
              <template slot="content">
                <div class="send-file-form" id="SendFile">
                  <input
                    type="file"
                    @change="changefile($event)"
                    class="d-none"
                    :key="RenderFile"
                    id="Uploader"
                    accept=".gif,.jpg,.jpeg,.png,.zip,.rar,.pdf"
                  />

                  <div
                    class="send-file-upload"
                    :class="{ 'has-file': hasFile }"
                    @click="onUploadClick"
                  >
                    <div class="send-file-upload__text">
                      <strong class="send-file-upload__title">{{
                        hasFile ? fileinfo.name : "بارگذاری فایل"
                      }}</strong>
                      <span class="send-file-upload__hint">{{
                        hasFile
                          ? fileSizeLabel(fileinfo.size)
                          : "برای انتخاب فایل کلیک کنید — تصویر، PDF یا ZIP تا ۵ مگابایت"
                      }}</span>
                    </div>
                    <div
                      class="send-file-upload__preview"
                      title="انتخاب فایل"
                    >
                      <i
                        :class="fileIconClass"
                        class="send-file-upload__icon"
                        aria-hidden="true"
                      ></i>
                      <i
                        v-if="!hasFile"
                        class="fas fa-plus send-file-upload__plus"
                        aria-hidden="true"
                      ></i>
                    </div>
                  </div>

                  <div v-if="hasFile" class="send-file-fields">
                    <label class="send-file-field">
                      <span class="send-file-label">عنوان فایل</span>
                      <input
                        id="OnvanFile"
                        type="text"
                        class="form-control required"
                        v-model="OnvanFile"
                        @input="CheckValue($event)"
                        placeholder="عنوان فایل را وارد کنید"
                      />
                    </label>
                    <div class="send-file-actions">
                      <button
                        type="button"
                        class="send-file-btn send-file-btn--primary"
                        @click="SendFileforAdmin"
                      >
                        <i class="fa fa-upload" aria-hidden="true"></i>
                        ارسال فایل
                      </button>
                      <button
                        type="button"
                        class="send-file-btn send-file-btn--ghost"
                        @click="Cancel"
                      >
                        <i class="fa fa-times" aria-hidden="true"></i>
                        انصراف
                      </button>
                    </div>
                  </div>
                </div>
              </template>
            </net-pa-card>
          </div>

          <div
            class="tab-pane fade"
            :class="{ 'show active': activeTab === 'nav-send-list' }"
            id="nav-send-list"
            role="tabpanel"
            aria-labelledby="nav-send-list-tab"
          >
            <net-pa-card :Compact="true">
              <template slot="content">
                <ListAzaFile
                  :key="RenderFile"
                  :ShowHeader="false"
                  :IsAdmin="false"
                  :wwwtblAzaId="AzaId"
                ></ListAzaFile>
              </template>
            </net-pa-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Loading from "../Tools/NetPa/Loading.vue";
import Panel from "../Tools/NetPa/Panel.vue";
import NetPaCard from "../Tools/NetPa/NetPaCard.vue";
import NetPaTab from "../Tools/NetPa/NetPaTab.vue";
import ListAzaFile from "./ListAzaFile.vue";

export default {
  components: { Panel, NetPaCard, NetPaTab, ListAzaFile, Loading },
  data() {
    return {
      activeTab: "nav-send-form",
      fileinfo: {},
      RenderFile: 0,
      AzaId: this.$session.get("UserInfoNetPa").wwwtblAzaId,
      Loading: false,
      Render: 0,
      OnvanFile: null,
      NotSend: true,
    };
  },
  computed: {
    SendFileTabs() {
      return [
        { id: "nav-send-form", title: "ارسال فایل" },
        { id: "nav-send-list", title: "فایل‌های ارسال‌شده" },
      ];
    },
    hasFile() {
      return !!(this.fileinfo && (this.fileinfo.size || this.fileinfo.name));
    },
    fileIconClass() {
      if (!this.hasFile) return "fas fa-paperclip";
      const ext = String(this.fileinfo.name || "")
        .split(".")
        .pop()
        .toLowerCase();
      if (["jpg", "jpeg", "png", "gif"].includes(ext)) return "fas fa-image";
      if (["zip", "rar"].includes(ext)) return "fas fa-file-archive";
      if (ext === "pdf") return "fas fa-file-pdf";
      return "fas fa-file";
    },
  },
  methods: {
    onTabChange(id) {
      this.activeTab = id;
    },
    switchTab(id) {
      this.activeTab = id;
      this.$nextTick(() => {
        const link = document.getElementById(id + "-tab");
        if (link && window.$) {
          window.$(link).tab("show");
        } else if (link) {
          link.click();
        }
      });
    },
    clickUploader() {
      const input = document.getElementById("Uploader");
      if (input) input.click();
    },
    onUploadClick() {
      this.clickUploader();
    },
    fileSizeLabel(size) {
      if (!size) return "";
      const mb = size / (1024 * 1024);
      if (mb < 0.1) return (size / 1024).toFixed(0) + " کیلوبایت";
      return mb.toFixed(2) + " مگابایت";
    },
    changefile(e) {
      const file = e.target.files[0];
      if (!file) return;

      const allowedExtensions = [
        "gif",
        "jpg",
        "jpeg",
        "png",
        "zip",
        "rar",
        "pdf",
      ];
      const fileExtension = file.name.split(".").pop().toLowerCase();
      if (!allowedExtensions.includes(fileExtension)) {
        this.$mySweetDefaultTost(
          "فرمت فایل مجاز نیست",
          `فرمت ${fileExtension} پشتیبانی نمی‌شود.`,
          "error",
          3000,
        );
        e.target.value = "";
        return;
      }
      if (file.size > 1024 * 1024 * 5) {
        this.$mySweetDefaultTost(
          "عملیات ناموفق",
          "  حجم فایل ارسالی بیشتر از 5 مگابایت است ",
          "error",
          3000,
        );
        this.fileinfo = {};
        this.RenderFile++;
        return;
      }
      this.fileinfo = file;
      if (!this.OnvanFile) {
        this.OnvanFile = file.name.replace(/\.[^.]+$/, "");
        this.NotSend = !String(this.OnvanFile).trim();
      }
    },
    SendFileforAdmin() {
      if (!this.$ValidForm("SendFile")) {
        return;
      }
      if (this.NotSend == true) {
        this.$mySweetDefaultTost(
          "ورودی نا معتبر",
          "وارد کردن عنوان فایل الزامی می باشد ",
          "error",
          1200,
        );
        return;
      }
      this.$SweetQustion(
        "اطمینان از ارسال فایل ",
        "از ارسال فایل خود اطمینان دارید؟ در صورت ارسال ، ویرایش فایل امکان پذیر نیست",
        "question",
        "تایید ",
        "انصراف",
        this.fileinfo,
        this.SendFile,
        this.isNotConfirmed,
      );
    },
    Cancel() {
      this.fileinfo = {};
      this.OnvanFile = null;
      this.NotSend = true;
      this.RenderFile++;
    },
    SendFile() {
      this.Loading = true;
      let DataAxiosUpload = {
        ArryfildValue: "",
        Method: "Post",
        Action: "EftetahHesab/SaveAttachmentToDb",
        Token: "",
      };
      var formdata = new FormData();
      formdata.append(
        "IdEftetah",
        this.$session.get("UserInfoNetPa").wwwtblAzaId,
      );
      formdata.append("Image", this.fileinfo);
      formdata.append("TableName", "FileToAdmin");
      formdata.append("wwwtblcomboidgrp328", null);
      formdata.append("FileTitle", this.OnvanFile);
      DataAxiosUpload.ArryfildValue = formdata;
      this.$PostFormData(DataAxiosUpload).then((data) => {
        this.Loading = false;
        if (data.status == "Ok") {
          this.$mySweetDefault(
            "ارسال موفق",
            "فایل شما با موفقیت برای مدیر سامانه ارسال گردید",
            "success",
            2000,
          );
          this.Cancel();
          this.switchTab("nav-send-list");
        } else {
          this.$mySweetDefault(
            "ارسال ناموفق",
            "فایل شما ارسال نشد  لطفا دقایق دیگر تلاش کنید",
            "danger",
            2000,
          );
          this.Cancel();
        }
      });
    },
    isNotConfirmed() {},
    CheckValue(ev) {
      if (ev.target.value.trim().length == 0) {
        ev.target.classList.add("wronginput");
        ev.target.focus();
        this.NotSend = true;
        this.$mySweetDefaultTost(
          "ورودی نا معتبر",
          "فیلد مشخص شده الزامی می باشد ",
          "error",
          1200,
        );
      } else {
        this.NotSend = false;
        ev.target.classList.remove("wronginput");
      }
    },
  },
};
</script>
<style>
#SendFileToAdmin .send-file-form {
  width: 100%;
}

#SendFileToAdmin .send-file-upload {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-width: 0;
  min-height: 72px;
  margin-bottom: 1rem;
  padding: 14px 16px;
  border: 1px solid #eef1f6;
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 8px 22px rgba(41, 52, 95, 0.06);
  cursor: pointer;
}

#SendFileToAdmin .send-file-upload:hover .send-file-upload__preview {
  border-color: #05b8c8;
  background: #e7f7fa;
}

#SendFileToAdmin .send-file-upload__text {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-items: flex-start;
  min-width: 0;
  gap: 0.15rem;
}

#SendFileToAdmin .send-file-upload__title {
  color: #1c2b3d;
  font-size: 14px;
  font-weight: 800;
  line-height: 1.6;
  overflow-wrap: anywhere;
  word-break: break-word;
}

#SendFileToAdmin .send-file-upload__hint {
  color: #068997;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.5;
}

#SendFileToAdmin .send-file-upload__preview {
  position: relative;
  flex: 0 0 56px;
  width: 56px;
  height: 56px;
  overflow: hidden;
  border: 1px dashed #b7c4d6;
  border-radius: 14px;
  background: #eef2fb;
}

#SendFileToAdmin .send-file-upload.has-file .send-file-upload__preview {
  border-style: solid;
  border-color: #dbe5eb;
}

#SendFileToAdmin .send-file-upload__icon,
#SendFileToAdmin .send-file-upload__plus {
  position: absolute;
  z-index: 1;
  pointer-events: none;
}

#SendFileToAdmin .send-file-upload__icon {
  top: 50%;
  left: 46%;
  color: #5b6f8a;
  font-size: 18px;
  transform: translate(-50%, -50%);
}

#SendFileToAdmin .send-file-upload__plus {
  right: 6px;
  bottom: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  color: #fff;
  font-size: 8px;
  border-radius: 50%;
  background: #05b8c8;
}

#SendFileToAdmin .send-file-fields {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
}

#SendFileToAdmin .send-file-field {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

#SendFileToAdmin .send-file-label {
  display: block;
  margin-bottom: 0.35rem;
  color: #29345f;
  font-size: 13px;
  font-weight: 700;
}

#SendFileToAdmin .send-file-field .form-control {
  width: 100%;
  min-height: 40px;
  padding: 0.4rem 0.75rem;
  color: #13243a;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
  border: 1px solid #dbe5eb;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 1px 3px rgba(41, 52, 95, 0.06);
}

#SendFileToAdmin .send-file-field .form-control:focus {
  border-color: #287db4;
  box-shadow: 0 0 0 3px rgba(5, 184, 200, 0.2);
  outline: none;
}

#SendFileToAdmin .send-file-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.6rem;
}

#SendFileToAdmin .send-file-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  min-height: 40px;
  padding: 0.45rem 1rem;
  border-radius: 12px;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
}

#SendFileToAdmin .send-file-btn--primary {
  color: #fff;
  border: 0;
  background: linear-gradient(110deg, #29345f, #56508d 58%, #8d58a4);
  box-shadow: 0 8px 18px rgba(41, 52, 95, 0.16);
}

#SendFileToAdmin .send-file-btn--ghost {
  color: #29345f;
  border: 1px solid #dbe5eb;
  background: #fff;
}

@media (min-width: 768px) {
  #SendFileToAdmin .send-file-form {
    max-width: 28rem;
  }

  #SendFileToAdmin .send-file-upload {
    min-height: 64px;
    padding: 12px 14px;
    border-radius: 16px;
  }

  #SendFileToAdmin .send-file-upload__preview {
    flex-basis: 48px;
    width: 48px;
    height: 48px;
  }

  #SendFileToAdmin .send-file-btn {
    min-width: 8.5rem;
  }
}

@media (max-width: 767px) {
  #SendFileToAdmin .send-file-upload {
    min-height: 68px;
    padding: 12px 14px;
  }

  #SendFileToAdmin .send-file-upload__title {
    font-size: 13px;
  }

  #SendFileToAdmin .send-file-btn {
    width: 100%;
  }
}
</style>
